import React, { useMemo } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { getWillShowNav4 } from '@atlassian/jira-navigation-apps-sidebar-nav4-rollout-core/src/common/utils/get-will-show-nav4/index.tsx';
import type { BoardToolSection, BoardToolWebItem } from '../../types.tsx';
import { BoardToolWebItemView } from './board-tool-section-view/board-tool-sub-item/index.tsx';
import { BoardToolSectionView } from './board-tool-section-view/index.tsx';

export function useConnectPluginSections(
	toolSections: (BoardToolSection | BoardToolWebItem)[],
): (BoardToolSection | BoardToolWebItem)[] | undefined {
	return useMemo(
		() => toolSections?.filter((section) => section.id !== 'board-tools-section'),
		[toolSections],
	);
}

export interface BoardToolsViewProps {
	toolSections: (BoardToolSection | BoardToolWebItem)[];
	mode?: 'button' | 'dropdown-item';
	onClickWebItem?: () => void;
}

export function BoardToolsView({
	toolSections,
	mode = 'button',
	onClickWebItem,
}: BoardToolsViewProps) {
	const relevantSections = useConnectPluginSections(toolSections);

	return (
		<>
			{relevantSections?.map((section) =>
				section.type === 'webItem' ? (
					<BoardToolWebItemView
						key={section.id}
						subItem={section}
						mode={mode}
						onClickWebItem={
							mode === 'dropdown-item' && fg('make_board_menu_popup') ? onClickWebItem : undefined
						}
					/>
				) : (
					<BoardToolSectionView
						key={section.id}
						section={section}
						isMenuItem={mode === 'dropdown-item' && getWillShowNav4()}
					/>
				),
			)}
		</>
	);
}
